import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';
import { env } from '@/config/env';
import type { PostHogEventName } from './posthog-events';

let initialized = false;

export function initPostHog(): void {
  const apiKey = env.VITE_POSTHOG_KEY;
  if (!apiKey) return;

  posthog.init(apiKey, {
    api_host: env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },
  });

  initialized = true;

  if (typeof posthog.sentryIntegration === 'function') {
    Sentry.addIntegration(posthog.sentryIntegration());
  }
}

export function getPostHogClient() {
  return initialized ? posthog : null;
}

/**
 * Capture a PostHog event safely (no-ops if PostHog is not initialized).
 * All event names must come from POSTHOG_EVENTS — never pass raw strings.
 */
export function capturePostHogEvent(
  event: PostHogEventName,
  properties?: Record<string, unknown>
): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}
